import { ArrowSeparateVertical } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowSeparateVertical12Line = createIcon(
  ArrowSeparateVertical,
  12,
  "Line"
);
export const IconArrowSeparateVertical16Line = createIcon(
  ArrowSeparateVertical,
  16,
  "Line"
);
export const IconArrowSeparateVertical20Line = createIcon(
  ArrowSeparateVertical,
  20,
  "Line"
);
export const IconArrowSeparateVertical24Line = createIcon(
  ArrowSeparateVertical,
  24,
  "Line"
);
export const IconArrowSeparateVertical32Line = createIcon(
  ArrowSeparateVertical,
  32,
  "Line"
);
export const IconArrowSeparateVertical48Line = createIcon(
  ArrowSeparateVertical,
  48,
  "Line"
);
export const IconArrowSeparateVertical64Line = createIcon(
  ArrowSeparateVertical,
  64,
  "Line"
);
